/*
 * ******************************************************************
 * Copyright (c) 2024-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

import { Component } from "@angular/core";
import { BaseComponent } from "@shared/components/base.component";

@Component({
    standalone: false,
    selector: 'breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ["./breadcrumb.component.scss"]
})
export class BreadcrumbComponent extends BaseComponent {

}
